import { UseMutationResult } from '@tanstack/react-query'

import { useAuthFetchWithResponse } from '@e3dc-react/shell/Hooks/AuthFetch'
import { usePortalMutation } from 'src/Libs/api'
import { updateInstallation } from 'src/Libs/installations/api/installation.api'
import { InstallationFormModel } from 'src/Libs/installations/models/installation.model'

interface UseUpdateInstallationParams {
  onSuccess?: (vars: InstallationMutationVariables) => void
  onError?: (error: Error) => void
  currentCountryCode: string
}

interface InstallationMutationVariables {
  installationId: number
  payload: InstallationFormModel
}

type UseUpdateInstallationReturnType = (
  data: Omit<UseUpdateInstallationParams, 'currentCountryCode'>
) => UseMutationResult<InstallationFormModel | null, unknown, InstallationMutationVariables>

export const useUpdateInstallation: UseUpdateInstallationReturnType = ({ onError, onSuccess }) => {
  const authFetch = useAuthFetchWithResponse()

  const mutationResult = usePortalMutation({
    mutationFn: async (vars: InstallationMutationVariables) => {
      const result = await updateInstallation(vars.installationId, vars.payload, authFetch)

      if (result.hasErrors) {
        throw result.error ?? new Error('Failed to update installation')
      }

      return result
    },
    onSuccess: (_, vars) => onSuccess?.(vars),
    onError: error => onError?.(error),
  })

  return mutationResult
}
